import type { PendingStatus } from "./types";

// Split out from sessionsRepo/routesRepo so the sync engine can clear an
// entry once its pending record is deleted after a successful sync, without
// creating a syncEngine <-> sessionsRepo/routesRepo import cycle (syncEngine
// calls the real api/* modules directly, not the repos).
const sessionStatusCache = new Map<number, PendingStatus>();
const routeStatusCache = new Map<number, PendingStatus>();

export function setSessionSyncStatus(id: number, status: PendingStatus): void {
  sessionStatusCache.set(id, status);
}

export function getSessionSyncStatus(id: number): PendingStatus | null {
  return sessionStatusCache.get(id) ?? null;
}

export function clearSessionSyncStatus(id: number): void {
  sessionStatusCache.delete(id);
}

export function setRouteSyncStatus(id: number, status: PendingStatus): void {
  routeStatusCache.set(id, status);
}

export function getRouteSyncStatus(id: number): PendingStatus | null {
  return routeStatusCache.get(id) ?? null;
}

export function clearRouteSyncStatus(id: number): void {
  routeStatusCache.delete(id);
}
